import { EngagementsState } from '@pages/talent-finder/store/states/engagements.state';

export const talentFinderState = [EngagementsState];
